// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import WesternSahara from '../_raw/flag/icon_flag_western_sahara.png';

export default () => <img src={WesternSahara} alt="WesternSahara" />;
